<template>
	<div>
		<div v-if="showPropsLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<div class="blue">
			<div class="p-3 d-flex position-relative justify-content-between" style="align-items: center;">
				<!-- <b-button v-if="format != 'big'" id="NavButton" variant="outline" @click="$emit('toggleNav')">
					<v-icon name="bars" class="text-white" scale="1.5" />
				</b-button> -->
				<img class="mbTopbarDiv1" src="../../../../public/img/taText_new_logo.png" height="55" />
				<div class="mbTopbarDiv2 title-wrapper">
					<h3 v-if="user" class="text-white center HeadProjTitle">{{user.Company}}
						<span class="custom-contact">
							<h6 v-if="user" class="text-white right">{{user.Contact}} {{user.Contact && getTimeZoneDetails ? '|':''}} {{getTimeZoneDetails}}</h6>
							<!-- <h6 v-if="format == 'big' && user" class="text-white right">{{getTimeZoneDetails}}</h6> -->
						</span>
					</h3>
				</div>
				
				<div style="margin-left:375px">
				
				</div>
				<div class="selectUserDropdownUI" v-if="isShowSubUser">
					<!-- <b-dropdown text="Select User" class='drop-zone' right variant="outline" toggle-class="text-white" style="z-index: 1005;padding-left:200px;">
						<b-dropdown-item :key="su.id" v-for="su in items" @click="changeUser(su)" class='drag-el'>{{su.Company}}</b-dropdown-item>
					</b-dropdown> -->
					
					<b-dropdown text="Select User" class='custom-draggble selectUserHeadDrop' right variant="outline" toggle-class="text-white" style="z-index: 9999;padding-left:200px;" >
						<div class="selectUserHeadList">
							<draggable :list="items" @start="drag=true" @end="onEnd">
								<div v-for="element in items" :key="element.id"> 
									<span style="cursor:pointer; font-size: 14px;" @click="changeUser(element)"> {{element.Company}} <br>
										<span class="UnreadAndDue">
											Unread Messages: (<span v-if="scope1">{{element.NewUnreadCount}}</span><span v-if="scope1Loader" class="loader4"></span>)
											<!-- | Tasks Due: (<span v-if="scope2">{{element.NewDueCount}}</span><span v-if="scope2Loader" class="loader4"></span>) -->
										</span>
									</span>
								</div>
							</draggable>
						</div>
					</b-dropdown>
					
				</div>
				<b-button  v-if="isShowBackButton" variant="outline"  @click="goBackToAuthUser()" style="margin-left: 435px;">
					<v-icon name="chevron-circle-left" class="text-white" scale="1.5" />
				</b-button>
				<div class="currentUserNameWithDropdownUI">
					<b-dropdown right variant="outline" toggle-class="text-white" style="z-index: 1005;">
						<template v-slot:button-content>
							<b class="HeadUserName">{{$parseAlias(user)}}</b>
						</template>
						<b-dropdown-item @click="$router.push('/home/Settings')">Settings</b-dropdown-item>
						<b-dropdown-item v-if="this.user.Version && this.user.Version==2" @click="$router.push('/home/Assessment')">Assessment</b-dropdown-item>
						<b-dropdown-item @click="$router.push('/home/Offices')">Offices</b-dropdown-item>
						<b-dropdown-item v-if="this.user.Version && this.user.Version==2" @click="$router.push('/home/Importing')">Importing</b-dropdown-item>
						<b-dropdown-item v-if="this.user.Version && this.user.Version==2" @click="$router.push('/home/OutOfArea')">Out Of Area</b-dropdown-item>
						<b-dropdown-item @click="$router.push('/home/Integrations')">Integrations</b-dropdown-item>
						<!-- <b-dropdown-item @click="$router.push('/home/SubUserList')">SubUser List</b-dropdown-item> -->
						<b-dropdown-item @click="$bvModal.show('SupportTicketModal')">Support</b-dropdown-item>
						<b-dropdown-divider/>
						<b-dropdown-item-button @click="$emit('logout')">Logout</b-dropdown-item-button>
					</b-dropdown>
				</div>
			</div>
		</div>
		
		<div class="setTopMenubar">
			<b-navbar toggleable="lg" type="dark" class="bnavbar">
				<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
				<b-collapse id="nav-collapse" is-nav>

					<b-navbar-nav class="leftSearch">
						<div class="d-flex w-100 position-relative">
							<div class="leftSearchDiv position-absolute px-2">
								<b-input-group>
									<b-input type="search" class="ProspectSearchUI" placeholder="Search Prospects..." v-model="search" debounce="500"/>
									<b-input-group-append>
										<b-button title="Add Prospect" class="AddProspectUI" variant="primary" @click="$bvModal.show('ProspectModal')">
											<v-icon name="plus" />
										</b-button>
									</b-input-group-append>
								</b-input-group>
								<b-list-group class="text-center">
									<b-list-group-item :key="prosp.id" v-for="prosp in filteredProspects" class="py-1" style="z-index: 1000" button @click="emitProsp(prosp)">
										{{$parseAlias(prosp)}}
									</b-list-group-item>
								</b-list-group>
							</div>
						</div>
					</b-navbar-nav>

					<b-navbar-nav class="mr-auto">
						<b-nav-item href="#" to="Pipeline" :class="{ 'active': page == 'Pipeline' }"><img src="../../../../public/img/Pipeline_W.png" class="nav-icon" /> Pipeline</b-nav-item>
						<b-nav-item href="#" to="/home/Conversations" @click="initConvoData" :class="{ 'active': page == 'Conversations' }"><img src="../../../../public/img/Conversations_W.png" class="nav-icon" /> Conversations ({{this.$store.state.firebase.unreadCount}})</b-nav-item>
						<b-nav-item href="#" to="/home/groupConversation" :class="{ 'active': page == 'groupConversation' }"><img src="../../../../public/img/group-chat.png" class="nav-icon" /> Group Conversation ({{unreadGroupConversationCount}})</b-nav-item>
						<b-nav-item href="#" to="/home/Tasklist" :class="{ 'active': page == 'Tasklist' }"><img style="height: 22px;width: 24px;margin-right: -2px;margin-top: -4px;margin-bottom: -2px;" src="../../../../public/img/Task-List-Check-White.png" class="nav-icon" /> Task List ({{draftTaskCountLoop}})</b-nav-item>
						<b-nav-item href="#" to="Campaigns" :class="{ 'active': page == 'Campaigns' }"><img src="../../../../public/img/Campaigns_W.png" class="nav-icon" /> Campaigns</b-nav-item>
						<b-nav-item href="#" to="Templates" :class="{ 'active': page == 'Templates' }"><img src="../../../../public/img/Templates_W.png" class="nav-icon" /> Templates</b-nav-item>
						<b-nav-item href="#" to="Managers" :class="{ 'active': page == 'Managers' }"><img src="../../../../public/img/Managers.png" class="nav-icon" /> Managers</b-nav-item>
						<b-nav-item href="#" :to="this.checkReportVersion()" :class="{ 'active': page == 'ReportingPage' }"><img src="../../../../public/img/Reporting.png" class="nav-icon" /> Reporting</b-nav-item>
						<!-- <b-nav-item href="#" @click="$bvModal.show('SupportTicketModal')">Support</b-nav-item> -->
					</b-navbar-nav>
				</b-collapse>
			</b-navbar>
		</div>

		<b-modal id="ProspectModal" hide-footer>
			<template v-slot:modal-title>
				Create Prospect
			</template>
			<b-form @submit.stop.prevent="createProspect">
				<b-form-group label-cols="5" label="First Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.First"
						required />
				</b-form-group>
				<b-form-group label-cols="5" label="Last Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.Last"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Email:" class="my-1">
					<b-form-input
						type="email"
						v-model="form.Email"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Phone number:" class="my-1">
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="form.Number"
						/>
				</b-form-group>
				<b-form-group label-cols="5" label="Postal Code:" class="my-1">
					<b-form-input
						type="text"
						@keydown="isCheckPostalCode($event)"
						v-model="form.Zip"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Status:" class="my-1">
					<b-form-select
						:options="user.Stages"
						v-model="form.Status"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Tags:" class="my-1">
					<b-form-checkbox-group v-model="form.Tags">
						<b-form-checkbox :value="user.Folders[i-1]" :key="i" v-for="i in user.Folders.length">
							{{user.Folders[i-1]}}
						</b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group>
				<b-form-group label-cols="5" label="Notes:" class="my-1">
					<b-form-input
						type="text"
						v-model="NoteValue"/>
				</b-form-group>
				<b-form-checkbox
					v-model="optIn"
					class="my-3"
					required>
						<small>This prospect has given me permission to contact them via text message</small>
				</b-form-checkbox>
				<b-button type="submit" block variant="outline-primary">Save Prospect</b-button>
			</b-form>
		</b-modal>

		<b-modal id="SupportTicketModal" centered  size="lg" hide-footer>
			<template v-slot:modal-title>
				Request a Support Ticket
			</template>
			<b-form>
				<b-form-group label-cols="2" label="Subject:" class="my-1">
					<b-form-input
						type="text"
						v-model="SupportTitle"
						required />
				</b-form-group>
				<b-form-group label-cols="2" label="Message:" class="my-2 send-editor">
					<vue-editor ref="vEditor" v-model="SupportMessage"></vue-editor>
				</b-form-group>
				<div class="cutom-fileUploder row">
					<div class="col-2"></div>
					<div  class="col-6" style="position:relative;">
						<input id="fileUpload" type="file" @change="SupportChangeFile($event)" style="cursor:pointer;margin-bottom:10px;height: 46px;opacity: 0;z-index: 9999;position: relative;"> 
						<div class="cutom-inputuploder">
							<span>Attach Document Here</span>
							<span><v-icon name="plus" class="" /></span>
						</div>
						<div v-if="SupportattachmentArray.length">
							<div v-for="(attach,i) in SupportattachmentArray" :key="i" class="attach-file-content">
								<span>{{attach.filename}}</span>
								<div @click="SupportDeleteAttachment(i)"><v-icon style="cursor:pointer;" name="trash" class="trash-icon-custom" /></div>
							</div>
						</div>
					</div>
					<div class="col-3" style="position: absolute; right: 3px;">
						<div class="SupportTicketBtn">
							<b-button v-if="!SupportisSending" variant="outline-primary" @click="SupportTicket()">Submit</b-button>
							<b-button v-if="SupportisSending" variant="outline-primary">Sending...</b-button>
						</div>
					</div>
				</div>
				
			</b-form>
		</b-modal>

		<b-modal id="LoginExpiredPopupUp" size="md" hide-header hide-footer no-close-on-backdrop>
			<div class="sessionExpiredDiv">
				<img src="../../../../public/img/sessionTimeout.png" />
				<h3>Session expired</h3>
				<p>Your session has expired. Please log in to continue accessing all features.</p>
				<a href="#" @click="$emit('logout')">Login</a>
			</div>
		</b-modal>
	</div>

</template>

<script>
	import { mapState } from 'vuex'
	import { db,auth,fbstore, getPhoneData } from 'src/db'
	import draggable from 'vuedraggable';
	import axios from "axios";
	import { VueEditor } from "vue2-editor";
	import moment from 'moment';
	export default {
		components: {
            draggable,
			VueEditor
        },
		name: 'Header',
		props: ['page'],
		computed: {
			filteredProspects() {
				if (!this.prospects.length || !this.search.length) {
					return [];
				}
				let prospMatches = this.prospects.filter(prosp => {
					let ret = false;
					if (prosp.Number) {
						ret = prosp.Number.includes(this.search) ||
								this.$parseNumber(prosp.Number).includes(this.search);
					}
					return ret || this.$parseAlias(prosp).toLowerCase().includes(this.search.toLowerCase());
				});
				if (prospMatches.length == 0) {
					return [{First: 'No', Last: 'Matches'}];
				}
				return prospMatches.slice(0, 15);
			},
			isShowBackButton() {
				let isShow = false;
				if (auth.currentUser.uid != this.user.Uid) {
					isShow = true;
				}
				return isShow
			},
			getTimeZoneDetails() {
				if (this.user.TimeZone == 0) {
                  return "Pacific Time";
				}else if (this.user.TimeZone == 1) {
                  return "Mountain Time";
				}else if (this.user.TimeZone == 2) {
                  return "Central Time";
				}else if (this.user.TimeZone == 3) {
                  return "Eastern Time";
				}else {
                  return '';
				}
			},
			// UNREAD MESSAGE COUNT
			unreadConversationCountLoop() {
				let uc = 0;
				if(this.convos != null) {
				this.convos.forEach(convosdata => {
					if(convosdata.Unread != 0) {
						uc = uc + 1;
					}
				});
				}
				//eslint-disable-next-line
				//console.log('this.unreadCount', uc);
				return uc;

				// this.$store.dispatch('firebase/rebindConvosUnreadCount', {
				// 	uid: this.user.Uid,
				// 	id: this.user.id,
				// })
				// .then(() => {
				// 	//eslint-disable-next-line
				// 	console.log("Conversation count:", this.$store.state.firebase.unreadCount);
				// 	const unreadCount = this.$store.state.firebase.unreadCount;
				// 	return unreadCount;
				// })

			},
			unreadGroupConversationCount() {
				let uc = 0;
				this.groupconvos.forEach(convosdata => {
					if(convosdata.Unread != 0) {
						uc = uc + 1;
					}
				});
				return uc;
			},
			// DUE DRAFT TASK COUNT
			draftTaskCountLoop() {
				let dc = 0;
				this.prospects.forEach(elementdata => {
					if(elementdata.Tasks) {
						elementdata.Tasks.forEach(elementdata1 => {
							if(elementdata1.Status == 'draft' && (elementdata1.DueOn <= Date.now())) {
								dc = dc + 1;
							}
						});
					}
				});
				//eslint-disable-next-line
				//console.log('this.taskCount', dc);
				return dc;
			},
			...mapState('globals', ['format','limit']),
			...mapState('firebase', ['user', 'convos', 'groupconvos', 'prospects', 'emails','calls'])
		},
		async mounted() {
			// SELECT USER DROPDOWN > COUNT NUMBER OF UNREAD MESSAGE
			this.$root.$on('bv::dropdown::show', () => {
				this.scope1=false;
				this.scope1Loader=true;
				this.scope2=false;
				this.scope2Loader=true;
				this.items.forEach(e1 => {
					
					let abc = 0;
					db.collection(`Conversations`).where('Uid', '==', e1.Uid).where('Unread', 'in', this.range(1,10)).get().then(x=>{
						//eslint-disable-next-line
						// console.log('one1',x.docs.length);
						abc = x.docs.length
						this.items.forEach(tuid=>{
							if (tuid.Uid == e1.Uid) {
								tuid['NewUnreadCount'] = abc;
							}
						})
						setTimeout(() => {
							this.scope1Loader=false;
							this.scope1=true;
						}, 1000);
					})

					// this.dueTaskListCount(e1.id);
					
				})
			})
		},
		async created() {
			
			// getSubUserList({UID: this.user.id})
			// 	.then((res) => {
			// 		this.items = res.data;
			// 		if (this.items.length) {
			// 			this.isShowSubUser = true;
			// 		}
            //     })
			//     .catch(err => alert(`Failure getting sub user list: ${err}`));
			
			let teamRef = await db.collection(`Team`).doc(`/zzxOvpZGle9GsNlZqisB`).get();
            const teamCollectionData = teamRef.data();
			let teams = [];
			//eslint-disable-next-line
			// console.log(teamCollectionData);
            if (teamCollectionData && (teamCollectionData.hasOwnProperty(this.user.Uid))) {
				teams = teamCollectionData[this.user.Uid].Teams;

				// let userRef = await db.collection(`Users`).where('Uid', 'in', teams).get();
				// let userCollectionData = userRef.docs.map((doc) => {
				// 	let data1 = { id: doc.id, ...doc.data() };
				// 	return data1;
				// });
				// this.items = userCollectionData;
				// this.isShowSubUser = true;

				if (!teams || !teams.length) return;
				if (teams.length > 10) {
					const collectionPath = db.collection(`Users`);
					let batches = [];
					while (teams.length) {
						// // firestore limits batches to 10
						// const batch = teams.splice(0, 10);
						// // add the batch request to to a queue
						// batches.push(
						// 	new Promise((response) => {
						// 		collectionPath.where('Uid','in',[...batch])
						// 		.get()
						// 		.then(results => response(results.docs.map(result => ({ ...result.data()}) )))
						// 	})
						// )

						const batch = teams.splice(0, 10);
						batch.forEach(async (element) => {
							batches.push(
								new Promise((response) => {
									collectionPath.where('Uid','==',element)
									.get()
									.then(results => response(results.docs.map(result => ({ ...result.data()}) )))
								})
							)
						});

					}
					// after all of the data is fetched, return it
					Promise.all(batches).then(content => {
						var merged = [].concat.apply([], content);
						this.items = merged;
						this.isShowSubUser = true;
					})

					//eslint-disable-next-line
					console.log('Log1...');
				}else {
					// let userRef = await db.collection(`Users`).where('Uid', 'in', teams).get();
					// let userCollectionData = userRef.docs.map((doc) => {
					// 	let data1 = { id: doc.id, ...doc.data() };
					// 	return data1;
					// });
					this.items = [];
					teams.forEach(async (element) => {
						let userRef = await db.collection(`Users`).where('Uid', '==', element).get();
						let userCollectionData = userRef.docs.map((doc) => {
							const ddata = doc.data();
							let data1 = { id: doc.id, Company:ddata.Company,Uid:ddata.Uid };
							return data1;
						});
						this.items.push(userCollectionData[0]);
					});
					// let userRef = await db.collection(`Users`).where('Uid', 'in', teams).get();
					// let userCollectionData = userRef.docs.map((doc) => {
					// 	let data1 = { id: doc.id, ...doc.data() };
					// 	return data1;
					// });
					// this.items = userCollectionData;
					this.isShowSubUser = true;
				}

			}
			this.checkLoginSession();
		},
		methods: {
			fetchConvoData(uid) {
                //eslint-disable-next-line
                console.log('userAuth.uid:', uid);
                this.$store.dispatch('firebase/rebindConvosNew', {uid:uid, page:1, limit:this.limit})
                .then(() => {
                    //eslint-disable-next-line
                    console.log('Data Successfully Fetched A');
                })
                .catch((err) => {
                    //eslint-disable-next-line
                    console.error('Error fetching conversation data:', err);
                });
            },
			initConvoData(){
				
				// let perPage = 20;
				//eslint-disable-next-line
				console.log('userAuth.uid:', this.user.Uid);
				this.$store.dispatch('firebase/rebindConvosNew', {uid:this.user.Uid, page:1, limit:this.limit})
				.then(() => {
					//eslint-disable-next-line
					console.log('Data fetched succsessfully:');
				})
				.catch((err) => {
					//eslint-disable-next-line
					console.error('Error fetching conversation count:', err);
				});
				this.$store.commit('globals/SET', { var: 'activeProsp', val: null });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: null });
			},
			checkLoginSession() {
				if(this.user && this.user.hasOwnProperty('AuthExpired')) { 
					if(this.user.AuthExpired < moment().valueOf()) { // 1686288880794 < 1683697344008
						//eslint-disable-next-line
						console.log("Session Expired");
						this.$bvModal.show('LoginExpiredPopupUp');
					}
				}
			},
			// SUPPORT FORM: ATTACH CHANGE FILE
			SupportChangeFile(event) {
				this.SupportfileData = event.target.files[0];
				this.SupportfileName = event.target.files[0].name;
				this.SupportonUpload();
				var reader = new FileReader();
				reader.readAsDataURL(this.SupportfileData);
				setTimeout(() => {
					let abc = reader.result.split(',');
					this.SupportfilePath = abc[1];
					this.fileType = this.SupportfileData.type;
					
				}, 100);
			},
			SupportonUpload(){
				const storageRef = fbstore.ref('Supports/'+this.SupportfileData.name).put(this.SupportfileData);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{	
						this.SupportuploadedURL = url;
						this.SupportattachmentArray.push({
							'content':this.SupportfilePath,
							'filename':this.SupportfileName,
							'type':this.fileType,
							'content_id':this.SupportfileName,
							// 'storedFilePath':this.SupportuploadedURL
						});
						this.SupportfilesArray.push({'name':this.SupportfileName,'path':this.SupportuploadedURL});
					});
				});
			},
			// SUPPORT FORM: DELETE ATTACHED FILE
			SupportDeleteAttachment(index) {
				var storageRef = fbstore.ref().child('Supports/'+this.SupportattachmentArray[index]['filename']);
				storageRef.delete().then(() => {
					this.SupportattachmentArray.splice(index,1);
				}).catch((error) => {
					//eslint-disable-next-line
					console.log('errror',error);
				});
			},
			getSupportEditorText() {
				var span = document.createElement('span');
				span.innerHTML = this.SupportMessage;
				return span.textContent || span.innerText;
			},
			// SUBMIT SUPPORT FORM
			SupportTicket() {
				if (this.SupportTitle && this.SupportMessage) {
					if (confirm("Are you sure you want to submit support ticket?")) {
						this.SupportisSending = true;
						const smsData = {
							toEmail:'logand@thirdpool.com',
							fromEmail:this.user.SendGrid,
							fromName:this.user.First + ' '+ this.user.Last,
							subject:this.SupportTitle,
							body:this.SupportMessage,
							fileName:this.SupportfileName,
							fileType:this.fileType,
							ccEmail:[this.user.Email],
							filePath:this.SupportfilePath,
							attachmentData:this.SupportattachmentArray,
							textBody:this.getSupportEditorText()
						};
						axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/sendEmail", smsData)
						.then(response => {
							this.SupportisSending = false;
							this.$bvModal.hide('SupportTicketModal');
							//eslint-disable-next-line
							console.log(response);
							setTimeout(() => {
								this.$bvToast.toast('Email is sent successfully!', {
									title: `Success`,
									variant: 'success',
									solid: true
								});
								this.SupportTitle = '';
								this.SupportMessage = '';
								this.SupportattachmentArray = [];
							}, 500);
						}).catch(err => 
							this.$bvToast.toast(`Failure Sending Email: ${err}`, {
								title: `Error`,
								variant: 'danger',
								solid: true
						})
						);
					}
				}else {
					alert('Please add Subject and Message');	
				}
			},
			async dueTaskListCount(eid) {
				let dueTaskList = [];
                let prospRef = await db.collection(`Users/${eid}/Prospects`).get();
                prospRef.docs.forEach(doc => {
                    if (doc.data().hasOwnProperty('Tasks') && doc.data().Tasks && doc.data().Tasks.length) {
                        doc.data().Tasks.forEach(element => {
                            if (element.Status == 'draft' && element.DueOn <= Date.now()) {
                                dueTaskList.push(element);
                            }
                        });
                    }
                });
				this.items.forEach(tuid1=>{
					if (tuid1.id == eid) {
						tuid1['NewDueCount'] = dueTaskList.length;
					}
				});
				setTimeout(() => {
					this.scope2Loader=false;
					this.scope2=true;
				}, 1000);
			},
			async emitProsp(prosp) {
				let convoSnap = await db.collection('Conversations')
					.where('ClientNumber', '==', prosp.Number)
					.where('Uid', '==', this.user.Uid)
					.orderBy('DateUpdated', 'desc')
					.get();
				let convoData = convoSnap.docs.map(doc => ({
									id: doc.id, 
									...doc.data(),
								}));
				// eslint-disable-next-line
				console.log('convoSnap', convoData);
				
				// db.doc(`Conversations/${convoData[0].id}`).update({DateUpdated: Math.floor(Date.now())});
				if (convoData.length > 0) {
				let findConvo;
                findConvo = convoData[0];
                // if (newConvo && !this.convos.some(convo => convo.id === newConvo.id)) {
				// 	var newN = [...this.convos,newConvo];
				// 	this.$store.commit('firebase/SET', { var: 'convos', val: newN });
				// }

				this.search = '';
				this.tempConvo = findConvo;
				
				// eslint-disable-next-line
				console.log('tempConvo', this.tempConvo);

				// if(this.convos != null) {
				// 	findConvo = this.convos.find(convo => convo.ClientNumber == prosp.Number);
				// }
				// eslint-disable-next-line
				console.log('findConvo', findConvo);
				if(findConvo){
					this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
					this.$store.commit('globals/SET', { var: 'activeConvo', val: findConvo.id });
					this.$store.dispatch('firebase/bindMessages', findConvo.id);
				}
				if (this.emails && this.emails.length) {
					let mid = this.getEmailConvoID(prosp.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
					// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prosp.id));
				}
				if(this.calls != null && this.calls.length){
				let cid = this.getCallsConvoID(prosp.id);
				if (cid) {
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
					}
				}
				if (this.$route.path != '/home/Conversations') {
					this.$router.push('/home/Conversations');
				}
				this.$emit('open', 'prosp');
			}
				// this.$store.dispatch('firebase/rebindConvosNew', {uid:this.user.Uid, page:1, limit:this.limit});
			},
			getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
			getCallsConvoID(prospId) {
				let phoneid = '';
				let phone = this.calls.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (phone) {
					phoneid = phone.id;
				}
				return phoneid;
			},
			async createProspect() {
				if (!this.optIn) {
					alert("Prospect cannot be added unless express permission is given");
					return;
				}
				if (this.NoteValue) {
					let notesArray = [{
						'date': Date.now(),
						'description': this.NoteValue,
						'mediaURL': ''
					}];
					this.form.Notes = notesArray;
				} else {
					this.form.Notes = [];
				}

				this.form.Stages = [{Date:new Date().valueOf(), Stage:this.form.Status}];
				
				this.$bvModal.hide('ProspectModal');
				this.showPropsLoader = true;
				
				if (this.form.Number) {
					await getPhoneData({Number:this.form.Number})
					.then((res) => this.showPhoneData(res))
					.catch(err => this.showPhoneError(err));
				}
				let formattedNum = this.form.Number;
				this.form.Number = this.$parseNumber(this.form.Number);

				/*if(this.form.Number == '' || this.form.Number === 'undefined') {
					if(this.prospects.find(prosp => prosp.First == this.form.First)) {
						this.showPropsLoader = false;
						alert("A prospect with this name already exists");
						return;
					}
				} else {
					if (this.prospects.find(prosp => prosp.Number == this.form.Number)) {
						this.form.Number = formattedNum;
						this.showPropsLoader = false;
						alert("A prospect with this number already exists");
						return;
					}
				}*/
				this.form.Source = 'Manual Entry';

				var endSpace = /\s+$/;
				if(this.form.First != '' && this.form.First !== 'undefined') {
                    if(endSpace.test(this.form.First)){
                        this.form.First = (this.form.First).replace(/\s+$/,''); 
                    }
                } 
				if(this.form.Last != '' && this.form.Last !== 'undefined') {
                    if(endSpace.test(this.form.Last)){
                        this.form.Last = (this.form.Last).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Email != '' && this.form.Email !== 'undefined') {
                    if(endSpace.test(this.form.Email)){
                        this.form.Email = (this.form.Email).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Zip != '' && this.form.Zip !== 'undefined') {
                    if(endSpace.test(this.form.Zip)){
                        this.form.Zip = (this.form.Zip).replace(/\s+$/,''); 
                    }
                }

				Promise.all([
					db.collection(`Users/${this.user.id}/Prospects`).add({
						...this.form,
						DateCreated: Date.now()
					}),
					// db.collection('Conversations').add({
					// 	ClientNumber: this.form.Number,
					// 	AgentNumber: this.user.Twilio,
					// 	Uid: this.user.Uid,
					// 	LastMessage: '',
					// 	DateUpdated: 0,
					// 	Unread: 0
					// })
					
				])
				.then(values => {
					this.form = {};
					this.form.Status = "New";
					this.optIn = false;
					// this.$bvModal.hide('ProspectModal');
					let prosp = this.prospects.find(prosp => values[0].id == prosp.id);
					if (prosp) {
						setTimeout(() => {
							this.showPropsLoader = false;
							this.emitProsp(prosp);
						}, 3000);
					}
					this.NoteValue = '';
				})
				.catch(err => {
					this.form.Number = formattedNum;
					this.$emit('error', err);
				})


				// Promise.all([
				// 	// db.collection(`Users/${this.user.id}/Prospects`).add({
				// 	// 	...this.form,
				// 	// 	DateCreated: Date.now()
				// 	// }),
				// 	db.collection('Conversations').add({
				// 		ClientNumber: this.form.Number,
				// 		AgentNumber: this.user.Twilio,
				// 		Uid: this.user.Uid,
				// 		LastMessage: '',
				// 		DateUpdated: 0,
				// 		Unread: 0
				// 	})
					
				// ])
				// .then(values => {
				// 	this.form = {};
				// 	this.optIn = false;
				// 	// this.$bvModal.hide('ProspectModal');
				// 	//eslint-disable-next-line
				// 	console.log(values);

				// 	// let prosp = this.prospects.find(prosp => values[0].id == prosp.id);
				// 	//eslint-disable-next-line
				// 	// console.log(prosp);
				// 	// this.emitProsp(prosp);
				// 	this.showPropsLoader = false;
				// })
				// .catch(err => {
					//eslint-disable-next-line
				// 	console.log('354',err);
				// 	this.form.Number = formattedNum;
				// 	this.$emit('error', err);
				// })
			},
			showPhoneData(res) {
				//eslint-disable-next-line
				// console.log(JSON.parse(res.data));
				let phoneData = JSON.parse(res.data);
				this.form.CarrierType = phoneData.carrier.type;
			},
			showPhoneError(err) {
				// this.showPropsLoader = false;
				this.form.CarrierType = null;
				alert(`Not able to find prospect Number Type : `+ err)
			},
			checkReportVersion() {
				let ReportVersion;
				if(this.user.Version == undefined || this.user.Version == 1) { 
					ReportVersion = 'ReportingPage'; 
				} else {
					ReportVersion = 'ReportingPagev2';
				}
				return ReportVersion;
			},
			changeUser(key) {
				this.$emit('changeUser',key);
			},
			goBackToAuthUser() {
				let key = {Uid:auth.currentUser.uid}
				this.$emit('changeUser',key);
			},
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			onEnd() {
				
				let team = [];
				this.items.forEach(element => {
					team.push(element.Uid)
				});
				let teams = {};
				teams = {'Teams':team};
				this.drag = false;
				db.doc(`Team/zzxOvpZGle9GsNlZqisB`).update({[this.user.Uid]:teams});

			},
			range(start, end) {
				return Array(end - start + 1).fill().map((_, idx) => start + idx)
			},
		},
		data() {
			return {
				isShowSubUser:false,
                items:[],
				drag:true,
				unredd:0,
				scope1:false,
				scope1Loader:true,
				scope2:false,
				scope2Loader:true,
				showPropsLoader:false,
				search: '',
				form: {
					Status:"New"
				},
				optIn: false,
				NoteValue:'',

				SupportTitle:'',
				SupportMessage: '',
				SupportfileName:'',
				SupportfileData:null,
				SupportfilePath:'',
				SupportattachmentArray:[],
				SupportuploadedURL:'',
				SupportfilesArray:[],
				SupportisSending:false,
				unreadCount:null,
				tempConvo:null
				
			}
		}
	}
</script>


<style>
#LoginExpiredPopupUp .sessionExpiredDiv{
	text-align: center;
    display: inline-block;
    width: 100%;
}
#LoginExpiredPopupUp .sessionExpiredDiv img{
	width:45%;
}
#LoginExpiredPopupUp .sessionExpiredDiv h3{
	font-size: 20px;
    color: #007bff;
}
#LoginExpiredPopupUp .sessionExpiredDiv p{
	font-size: 14px;
    color: #888888;
    margin: 12px 0px 24px;
}
#LoginExpiredPopupUp .sessionExpiredDiv a, 
#LoginExpiredPopupUp .sessionExpiredDiv a:hover{
	background: #007bff;
    color: #fff;
    padding: 10px 30px;
    border-radius: 30px;
    display: inline-block;
    text-decoration: none;
    margin-bottom: 12px;
    font-size: 14px;
}
.cutom-inputuploder {
    border: 1px dashed #ccc;
    padding: 10px;
    border-radius: 3px;
    position: absolute;
    left: 0;
    top: 0;
	margin-left: 12px;
    width: 294px;text-align: center;
    /* z-index: 9999; */
}
.cutom-inputuploder span {
    color: #ccc;
    display: inline-block;
    text-align: center;padding-right: 10px;
}

.attach-file-content span {
    padding-right: 10px;width: 100%;
	/* cursor: pointer; */
}

.attach-file-content {
    /* padding-left: 12px; */
    /* padding-bottom: 10px; */
    padding: 5px 10px;
    margin-bottom: 10px;
    box-shadow: 0px 0px 3px 1px #ebe7e7;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    display: flex;
    align-items: center;
}
.HeadUserName{
	font-size: 15px;
}
.selectUserHeadList{
overflow-y: scroll;
max-height: 500px;
min-height: auto;
}
.selectUserHeadDrop button{
	font-size: 14px;
}
.HeadProjTitle {
    font-size: 24px;
	margin-top: 5px!important;
	text-align: center;
}
span.custom-contact {
    display: flex;
    align-items: center;
    width: 100%;justify-content: center;
}

span.custom-contact h6.text-white.right {
    padding-right: 0px;
    font-size: 14px;
	margin-top: 2px;
	color: #dfdfdf!important;
}
.custom-draggble ul.dropdown-menu div div {
    padding: 5px 5px;
    border-bottom: 1px solid rgb(4 43 121 / 20%);
    cursor: move;
}
.custom-draggble ul.dropdown-menu div div:last-child {
    border: none;
}
.custom-draggble ul.dropdown-menu{
    padding: 0 !important;
}
.custom-draggble ul{
	position: absolute;
    will-change: transform;
    top: 40px !important	;
    left: 0px;
    transform: none !important;
}
.loader4 {
   width:13px;
   height:13px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:3px solid;
   border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}
.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
.UnreadAndDue{
	color: #7e7e7e;
	font-size: 13px;
}
.SupportTicketBtn{
	text-align: right;
}
.SupportTicketBtn button {
	width: 100%;
    height: 40px;
}
</style>